export default __webpack_public_path__ + "static/media/store_promo.e943b8c7.png";